<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { replace, querystring } from 'svelte-spa-router';
	import { 
		TipoEvento,
		API, 
		cabecalhoPadraoRequisicao,
		limparLocalStorage, 
		TextoFeedback,
		carregarEditorTexto,
		enviarDadosFormulario } from '../../utils';
	import TBox from '../templates/TBox.svelte';
	
	// The params prop contains values matched from the URL
	export let params = {}

	const dispatch = createEventDispatcher();
	
	let flagVisibilidade = false;
	let editorCarregado = false;
	let idProjeto;
	let relatorio = {};
	let corpoPatch = {};
	let prazoLimiteInicial, prazoLimiteFinal;
	let tituloProjeto;

	onMount(async () => {
		idProjeto = params.idProjeto;
		const informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando relatório ...',
		});

		prazoLimiteInicial = informacosAPICache.prazos.cadastro_relatorios_projeto_inicio;
		prazoLimiteFinal = informacosAPICache.prazos.cadastro_relatorios_projeto_fim;
		
		const resposta = await fetch(API(`projetos/relatorios/${params.codigoProjeto}/${params.idRelatorio}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("#/painel");
		});

		const { dados } = await resposta.json();
		relatorio = dados;

		if (relatorio === undefined) replace('#/relatorio-inexistente');

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		let parametrosURL = new URLSearchParams($querystring);
		tituloProjeto = decodeURIComponent(escape(window.atob(parametrosURL.get('tp'))));
	});

	const carregarEditor = () => {
		flagVisibilidade = true;
		
		if (editorCarregado == false)
			carregarEditorTexto('editor-descricao-relatorio', relatorio.conteudo, true, (valor) => editorCarregado = valor);
	}

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Enviando os dados ...',
		});
			
		// verificar se editor foi carregado, indicando que houve alteração de dados da descrição do relatório, caso contrário, avisa e retorna que nada foi feito.
		if (editorCarregado) {
			corpoPatch = JSON.stringify({
				idProjeto: idProjeto,
				idRelatorio: relatorio.id,
				conteudo: editor.getData()
			});
		} else {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Aviso',
				conteudo: 'Nenhuma informação do relatório foi atualizada.'
			});

			replace('#/painel');
			return;
		}
		
		let operacao = enviarDadosFormulario('PATCH', dispatch, replace, 'projetos/relatorios', corpoPatch, 
			'Relatório atualizado com sucesso.', 
			'#/painel/projetos',
			'#/projetos'
		);

		if (operacao) limparLocalStorage(false, false, false, true);
	}
</script>

<TBox 
	titulo="Atualização (RELATÓRIO)" 
	subtitulo="Formulário de atualização (relatório de projeto)" 
	largura="12" 
	deslocamento="0" 
	icone="projeto">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column">
				<div class="box">
					<p>Projeto: <strong>{ tituloProjeto }</strong></p>
					<p>Código: <strong>{ params.codigoProjeto }</strong></p>
					<p>Tipo relatório: <strong>{ relatorio.tipo }</strong></p>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column is-5">
				<div class="notification is-danger is-light">Prazo para cadastro e alterações: de <strong>{prazoLimiteInicial}</strong> até <strong>{prazoLimiteFinal}</strong>.</div>
			</div>
			<div class="column">
				<div class="notification is-info is-light">Clique no botão abaixo para abrir o editor de textos para realizar as alterções desejados no conteúdo do relatório. Não é possível alterar o tipo de relatório.</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<button class="button is-info is-medium is-fullwidth py-6 {flagVisibilidade == true ? 'is-hidden' : ''}" on:click|preventDefault={carregarEditor}>Clique aqui para carregar o editor</button>
				<textarea name="descricao" class="content editor-descricao-relatorio {flagVisibilidade == false ? 'is-hidden' : ''}"></textarea>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column">
				<p class="control">
					<a href="#/painel" class="button is-black is-medium is-outlined is-fullwidth">Painel</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Alterar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>